import React from 'react';

interface ReadingIconProps {
  color?: string;
  size?: number;
}

export const ReadingIcon: React.FC<ReadingIconProps> = ({
  color = '#E6E6F1',
  size = 13,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.40007 10.1885C5.67031 9.76714 4.8425 9.54532 3.99984 9.54532C3.15718 9.54532 2.32937 9.76714 1.59961 10.1885V3.25447C2.32937 2.83314 3.15718 2.61133 3.99984 2.61133C4.8425 2.61133 5.67031 2.83314 6.40007 3.25447M6.40007 10.1885C7.12983 9.76714 7.95764 9.54532 8.8003 9.54532C9.64295 9.54532 10.4708 9.76714 11.2005 10.1885V3.25447C10.4708 2.83314 9.64295 2.61133 8.8003 2.61133C7.95764 2.61133 7.12983 2.83314 6.40007 3.25447M6.40007 10.1885V3.25447"
        stroke={color}
        strokeOpacity="0.5"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
